var selectToken = function selectToken(group, path) {
  if (!path) return undefined;
  return group[path];
};
var selectIntentColorToken = function selectIntentColorToken(intentToken, colorType, path) {
  var intent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'generic';
  if (!path) return undefined;
  var tokenValue = intentToken[intent][colorType][path];
  return tokenValue;
};
var selectTokens = function selectTokens(group, path, length, none) {
  if (!path) return undefined;
  if (!Array.isArray(path)) return group[path];
  if (!length) return path.map(function (p) {
    return group[p];
  }).join(' ');
  var value = '';
  for (var index = 0; index < length; index += 1) {
    value += group[path[index]] || none || 0;
    if (index < length - 1) value += ' ';
  }
  return value;
};

export { selectIntentColorToken, selectToken, selectTokens };
//# sourceMappingURL=tokenSelector.js.map
